module.exports = __webpack_public_path__ + "static/img/8.2a98e509.jpg";